<script setup lang="ts">
import { computed, ref } from "vue";
import { locale } from "../../../locale";
import ToolTip from "../../ToolTip.vue";
import { toggleChat, viewState } from "../../../states/viewState";
import { isNewMessages } from "../../../states/readMarkState";
// import { useFloatingChat } from "../../../states/ui";
const btn = ref<HTMLElement | null>(null);
const tooltip = computed(() => {
  if (viewState.rightBlockContent === 'chat') {
    return locale.chat.close;
  } else {
    return locale.chat.open;
  }
});
// const floating = useFloatingChat()
</script>
<template>
  <button ref="btn" class="chat-button" @click="toggleChat" :class="{
    active: viewState.rightBlockContent === 'chat',
    // floating: floating,
  }">
    <div class="new-messages-mark" v-if="!(viewState.rightBlockContent === 'chat') && isNewMessages"></div>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.4004 3.83984H5.60039C3.83308 3.83984 2.40039 5.27253 2.40039 7.03984V14.5065C2.40039 16.2738 3.83308 17.7065 5.60039 17.7065H7.73372L12.0004 20.9065V17.7065H18.4004C20.1677 17.7065 21.6004 16.2738 21.6004 14.5065V7.03984C21.6004 5.27253 20.1677 3.83984 18.4004 3.83984Z"
        stroke="currentColor" stroke-width="1.5" />
    </svg>
    <ToolTip :placement="'top'" :reference="btn">{{ tooltip }}</ToolTip>
  </button>
</template>
<style scoped>
.chat-button {
  position: relative;
  width: 44px;
  height: 44px;
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  background: var(--bottom-btn-off-bg-regular);
  color: var(--bottom-btn-off-content-regular);
  backdrop-filter: blur(2px);
  border-radius: 50px;
  border: none;
  cursor: pointer;
  transition: transform 0.3s ease-in-out;
  transform: translateY(0px);
}

.chat-button.floating {
  transform: translateY(-76px);
}

.new-messages-mark {
  position: absolute;
  width: 12px;
  height: 12px;
  top:0;
  right: 0;
  background-color: var(--marker-alert-color);
  border-radius: 50%;
}

.chat-button:disabled {
  cursor: default;
}

.chat-button:hover:not(.inactive) {
  background-color: var(--bottom-btn-off-bg-hover);
  color: var(--bottom-btn-off-content-hover);
}

.chat-button:active:not(.inactive) {
  background-color: var(--bottom-btn-off-bg-active);
  color: var(--bottom-btn-off-content-active);
}

.chat-button:focus:not(.inactive) {
  outline: none;
}

.chat-button.active:hover:not(.inactive) {
  background-color: var(--bottom-btn-on-bg-hover);
  color: var(--bottom-btn-on-content-hover);
}

.chat-button.active:active:not(.inactive) {
  background-color: var(--bottom-btn-on-bg-active);
  color: var(--bottom-btn-on-content-active);
}

.chat-button.active:not(.inactive) {
  background-color: var(--bottom-btn-on-bg-regular);
  color: var(--bottom-btn-on-content-regular);
}
</style>
